<template>
  <div :class="[prefixCls + '__container']">
    <transition :name="transitionNames">
      <div v-show="currentVisibled" v-clickoutside="$_onClickoutSide" :class="contentClazz" :style="styls">
        <div :class="[prefixCls + '__header']">
          <slot name="header">
            <div :class="headerInnerClazz">
              <t-icon :icon="arrowType" :class="headerArrowClazz" @click.native="$_onHideSlip"></t-icon>
              <span :class="[prefixCls + '__title']">{{ title }}</span>
            </div>
          </slot>
        </div>
        <div :class="[prefixCls + '__body']">
          <slot></slot>
        </div>
      </div>
    </transition>
    <div v-if="shadow" :class="modalClass"></div>
  </div>
</template>

<script>
import {
  PREFIX_CLASS
} from '@/utils/constants'
import clickoutside from '@/directives/click-outside'
import TIcon from '@/module/icon'
const PREFIXCLS = `${PREFIX_CLASS}slipbox`
let cached
function getScrollBarSize (fresh) {
  if (fresh || cached === undefined) {
    const inner = document.createElement('div')
    inner.style.width = '100%'
    inner.style.height = '200px'
    const outer = document.createElement('div')
    const outerStyle = outer.style
    outerStyle.position = 'absolute'
    outerStyle.top = 0
    outerStyle.left = 0
    outerStyle.pointerEvents = 'none'
    outerStyle.visibility = 'hidden'
    outerStyle.width = '200px'
    outerStyle.height = '150px'
    outerStyle.overflow = 'hidden'
    outer.appendChild(inner)
    document.body.appendChild(outer)
    const widthContained = inner.offsetWidth
    outer.style.overflow = 'scroll'
    let widthScroll = inner.offsetWidth
    if (widthContained === widthScroll) {
      widthScroll = outer.clientWidth
    }
    document.body.removeChild(outer)
    cached = widthContained - widthScroll
  }
  return cached
}

export default {
  name: 'TSlipbox',
  directives: {
    clickoutside
  },
  components: {
    TIcon
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    visibled: {
      type: Boolean,
      default: false
    },
    transitionName: {
      type: String,
      default: ''
    },
    direction: {
      type: String,
      default: 'right',
      validator: value => {
        return ['left', 'right'].includes(value)
      }
    },
    styles: {
      type: Object,
      default: () => {}
    },
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    },
    // 是否需要显示backUp
    shadow: {
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line
    beforeClose: {
      type: Function
    }
  },
  data () {
    return {
      prefixCls: PREFIXCLS,
      bodyIsOverflowing: false,
      currentVisibled: false
    }
  },
  computed: {
    // model: {
    //   set (val) {
    //     if (val) {
    //       this.$_addScrollEffect()
    //       this.$emit('on-slip-show')
    //     } else {
    //       this.$_removeScrollEffect()
    //       this.$emit('on-slip-hide')
    //     }
    //     this.$emit('input', val)
    //   },
    //   get () {
    //     return this.value
    //   }
    // },
    modalClass() {
      return [PREFIX_CLASS + 'modal-backdrop', PREFIXCLS + '__wrap--backdrop', { 'show': this.currentVisibled }]
    },
    transitionNames() {
      if (!this.transitionName) {
        return this.direction === 'left' ? 'move-left' : 'move-right'
      } else {
        return this.transitionName
      }
    },
    contentClazz () {
      return [
        `${PREFIXCLS}__content`,
        {
          [`${PREFIXCLS}__content--show`]: this.currentVisibled
        },
        {
          [`${PREFIXCLS}__content--hide`]: !this.currentVisibled
        },
        {
          [`${PREFIXCLS}__content--right`]: this.direction === 'right'
        },
        {
          [`${PREFIXCLS}__content--left`]: this.direction !== 'right'
        },
        {
          [`${PREFIXCLS}__content--hasBack`]: this.needBackDrop
        }
      ]
    },
    headerInnerClazz() {
      return [
        `${PREFIXCLS}__header--inner`,
        {
          [`${PREFIXCLS}__header--border`]: this.title // '#979797'
        }
      ]
    },
    headerArrowClazz() {
      return [
        `${PREFIXCLS}__arrow`,
        {
          [`${PREFIXCLS}__arrow--left`]: this.direction === 'left'
        }
      ]
    },
    arrowType() {
      return this.direction === 'left' ? 'arrow-left-outline' : 'arrow-right-outline'
    },
    styls() {
      let sty = {}
      const WIDTH = 'width'
      const HEIGHT = 'height'
      if (this.width) {
        sty[WIDTH] = this.width + 'px'
      }
      if (this.height) {
        sty[HEIGHT] = this.height + 'px'
      }
      if (this.needBackDrop) {
        sty['zIndex'] = 1051
      }
      return Object.assign(this.styles || {}, sty)
    }
  },
  watch: {
    visibled(val) {
      this.currentVisibled = val
      if (val === false) {
        this.$_removeScrollEffect()
        this.$emit('on-slip-hide')
      } else {
        this.$_addScrollEffect()
        this.$emit('on-slip-show')
      }
    }
  },
  mounted() {
    this.currentVisibled = this.visibled
  },
  methods: {
    $_onHideSlip () {
      if (typeof this.beforeClose === 'function') {
        this.beforeClose(this.$_hide)
      } else {
        this.$_hide()
      }
    },
    $_fireEventOnPromise(eventName) {
      // eslint-disable-next-line
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line
        this.$emit(eventName, resolve, reject)
      })
    },
    $_hide () {
      this.currentVisibled = false
      this.$emit('update:visibled', false)
    },
    $_isChildNode(child, parent) {
      while (
        child !== undefined &&
        child !== null &&
        child.tagName &&
        child.tagName.toUpperCase() !== 'BODY'
      ) {
        if (child === this.$el.getElementsByClassName(parent)[0]) {
          return true
        }
        child = child.parentNode
      }
      return false
    },
    $_ischild(child) {
      while (
        child !== undefined &&
        child !== null &&
        child.tagName &&
        child.tagName.toUpperCase() !== 'BODY'
      ) {
        if (child === this.$el) {
          return true
        }
        child = child.parentNode
      }
      return false
    },
    $_isNotDropDown(child) {
      while (
        child !== undefined &&
        child !== null &&
        child.tagName &&
        child.tagName.toUpperCase() !== 'BODY'
      ) {
        if (child.classList.contains('dropdown__menu')) {
          return true
        }
        child = child.parentNode
      }
      return false
    },
    $_onClickoutSide(evt) {
      let val = false
      if (
        evt.target.classList.contains('slipbox__wrap--backdrop') ||
        evt.target.tagName === 'body'
      ) {
        this.$_onHideSlip()
        val = true
      } else if (
        this.$_ischild(evt.target) &&
        (!evt.target.classList.contains('slipbox__content') ||
          !this.$_isChildNode(evt.target, 'slipbox__content'))
      ) {
        this.$_onHideSlip()
        val = true
      }
      return val
    },
    // control if has scrollbar
    $_checkScrollBar() {
      let fullWindowWidth = window.innerWidth
      if (!fullWindowWidth) {
        // workaround for missing window.innerWidth in IE8
        const documentElementRect = document.documentElement.getBoundingClientRect()
        fullWindowWidth =
          documentElementRect.right - Math.abs(documentElementRect.left)
      }
      this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
      if (this.bodyIsOverflowing) {
        this.scrollBarWidth = getScrollBarSize()
      }
    },
    $_setScrollBar() {
      if (this.bodyIsOverflowing && this.scrollBarWidth !== undefined) {
        document.body.style.paddingRight = `${this.scrollBarWidth}px`
      }
    },
    $_resetScrollBar() {
      document.body.style.paddingRight = ''
    },
    $_addScrollEffect() {
      this.$_checkScrollBar()
      this.$_setScrollBar()
      document.body.style.overflow = 'hidden'
    },
    $_removeScrollEffect() {
      document.body.style.overflow = ''
      this.$_resetScrollBar()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/slipbox/index.vue